import styled from 'styled-components';
import { color, container, fontSize, spacing } from '../../../theme';

export const StyledWhenWatch = styled.div``;

export const StyledWhenWatchIcon = styled.div`
  width: ${spacing('xl4')};
  height: ${spacing('xl4')};
  margin: auto;
  margin-bottom: -${spacing('xs')};
  margin-top: ${spacing('xl')};
`;

export const StyledWhenWatchIntro = styled.div`
  max-width: ${container('sm')};
  margin: auto;
  margin-bottom: ${spacing('md')};
  text-align: center;
  font-size: ${fontSize('sm')};
`;

export const StyledWhenWatchFaqs = styled.dl`
  margin: auto;
  max-width: ${container('md')};
  border-bottom: 1px solid ${color('midnight_200')};
  counter-reset: faqs;
`;
